
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './hooks/useScrollTop'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SplashScreen } from '@capacitor/splash-screen'
import { trackPwaEvent, isAppInstalled, PWA_EVENTS } from './utils/pwaTracking'
import PageViewTracker from './components/analytics/PageViewTracker'
import { UpdateNotification } from './components/ui/UpdateNotification'

// Force light mode
document.documentElement.classList.remove('dark');
document.documentElement.classList.add('light');

// Check if app is running in installed mode
if (isAppInstalled()) {
  // Track that the app was launched in installed mode
  trackPwaEvent('app_launched_installed_mode');
}

// Hide splash screen when app is ready
document.addEventListener('DOMContentLoaded', () => {
  SplashScreen.hide();
});

// Enhanced service worker registration for cache busting
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('ServiceWorker registered: ', registration);
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available
                console.log('New app version available');
              }
            });
          }
        });
      })
      .catch(error => {
        console.error('ServiceWorker registration failed: ', error);
      });
  });
}

// Create QueryClient
const queryClient = new QueryClient();

// Create root and render app
const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ScrollToTop />
        <PageViewTracker />
        <UpdateNotification />
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  );
}
